import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

import Buttons from "./components/Buttons";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";
import Header from "./components/Header";
import Share from "./components/Share";
import VideoPlayer from "./components/VideoPlayer";
import GravityFormsA11y from "./components/GravityFormsA11y";

import DataLink from "./data-attributes/DataLink";
import EscapeEventListener from "./events/EscapeEventListener";
import {GlobalVariables} from "./GlobalVariables";


export default class StarterKit {
	constructor() {
		// First
        new SmoothScroll();
		new ResizeEvents();
		new EscapeEventListener();
		new EventListeners();
		new MobileCheck();
		new DevHelpers();

		// Data utils
		new DataLink();
		new Gallery();
		GlobalVariables.header = new Header();
		new RichText();
		new Share();
		new VideoPlayer();
		new GravityFormsA11y();

        const augmentButtons = () => {
            new Buttons();
        };
        augmentButtons();

        if (window.jQuery) {
            const $ = window.jQuery; // Utiliser le jQuery exposé par WordPress


            $(document).on('gform_post_render', (event, form_id, current_page) => {
                augmentButtons();
            });
        } else {
            console.warn("jQuery est manquant. L'écouteur gform_post_render ne peut pas être établi correctement.");
        }
	}
}
